import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`

export const NextRequestDateContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  align-items: center;
  padding: ${props => props.theme.spacing.sp8};
  background-color: ${props => props.theme.colors.info.surface};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`
